/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Route } from 'react-router';
import Login from '../Login';
import LostPassword from '../LostPassword';
import ResetPassword from '../User/ResetPassword';

const LoginRoutes = (
  <Route>
    <Route path="login" component={Login} />
    <Route path="lostpassword" component={LostPassword} />
    <Route path="password_reset/:token" component={ResetPassword} />
  </Route>
);

export default LoginRoutes;




// WEBPACK FOOTER //
// ./src/containers/Routes/LoginRoutes.jsx